// Phase 12: Intent Memory Graph (Store)
// Records past user intents, visited locations, and outcomes to inform future sessions.

export interface MemoryNode {
    id: string;
    type: "intent" | "venue" | "district";
    label: string;
    metadata: any;
}

export interface MemoryEdge {
    from: string;
    to: string;
    weight: number; // Represents frequency/preference
    lastInteraction: number;
}

let nodes: Map<string, MemoryNode> = new Map();
let edges: MemoryEdge[] = [];

// Initialize with some "learned" baseline nodes if empty
if (nodes.size === 0) {
    const baselineNodes: MemoryNode[] = [
        { id: "i_rooftop", type: "intent", label: "Rooftop Bars", metadata: {} },
        { id: "d_financial", type: "district", label: "Financial District", metadata: {} },
        { id: "d_coastal", type: "district", label: "Coastal District", metadata: {} }
    ];
    baselineNodes.forEach(n => nodes.set(n.id, n));
}

export const memoryGraphStore = {
    addNode(node: MemoryNode) {
        if (!nodes.has(node.id)) {
            nodes.set(node.id, node);
        }
    },

    addEdge(from: string, to: string) {
        const existing = edges.find(e => e.from === from && e.to === to);
        if (existing) {
            existing.weight += 1;
            existing.lastInteraction = Date.now();
        } else {
            edges.push({ from, to, weight: 1, lastInteraction: Date.now() });
        }
    },

    getNodesByType(type: "intent" | "venue" | "district") {
        return Array.from(nodes.values()).filter(n => n.type === type);
    },

    getRecommendations(nodeId: string) {
        // Find nodes connected to this one, sorted by weight
        return edges
            .filter(e => e.from === nodeId)
            .sort((a, b) => b.weight - a.weight)
            .map(e => nodes.get(e.to))
            .filter(Boolean);
    },

    exportGraph() {
        return { 
            nodes: Array.from(nodes.values()), 
            edges 
        };
    }
};

if (typeof window !== 'undefined') {
    (window as any).WingmanMemoryGraph = memoryGraphStore;
}
